import classNames from 'classnames';
import { fromSwiftDate } from 'helpers/swiftDateFormatter';
import { DateTime } from 'luxon';
import { observer } from 'mobx-react-lite';
import { useTenancy } from 'state';
import { ViewPayments, ViewPaymentsHeader } from '../../bricks';
import { ViewPaymentsRentDetails, ViewPaymentsRentPayments } from './bricks';
import styles from './ViewPaymentsRent.module.scss';

/**
 * ViewPaymentsRent
 *
 * @return {JSX.Element}
 */
const ViewPaymentsRent = ({ className }) => {
  const tenancyDoc = useTenancy();
  const { data: tenancy } = tenancyDoc;
  const startsString = DateTime.fromJSDate(
    fromSwiftDate(tenancy.dates?.startDate)
  ).toLocaleString(DateTime.DATE_FULL);

  return (
    <ViewPayments
      className={classNames(
        styles.ViewPaymentsRent,
        className,
        ViewPaymentsRent.displayName
      )}
      header={
        <ViewPaymentsHeader
          label={`STATUS - STARTS ${startsString}`}
          currentValue={tenancy.payments?.depositAmountPaid}
          expectedValue={
            tenancy.durationInMonths * tenancy.payments?.rentAmount
          }
        />
      }
      details={<ViewPaymentsRentDetails />}
      payments={<ViewPaymentsRentPayments />}
    />
  );
};

ViewPaymentsRent.displayName = 'ViewPaymentsRent';

export default observer(ViewPaymentsRent);
